import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PropTypes from 'prop-types'
import { Button, Form, FormGroup,
         Label, Input, Col } from 'reactstrap';
import validator from 'validator';
import { NavLink } from 'react-router-dom';
import { saveSettings,
        getSettings } from '../../actions/settingActions';
import { getLicansePlate,
        getBalanceAccount } from '../../actions/infoAccountActions';
import { connect } from 'react-redux';
import IndicatorLoading from './../indicatorLoading/IndicatorLoading';
import Alert from './../Alert/Alert';
import { hideAlert } from './../../actions/AlertActions';
import T from 'i18n-react';

const requireLicensePlate = <T.text tag='span' text="licplate_req"/>;
const charactersLicensePlate = <T.text tag='span' text="lic_plate_symbol_valid"/>;
const requireEmail = <T.text tag='span' text="email_req_setting"/>;
const formatEmail = <T.text tag='span' text="email_format"/>;
const requirePincode = <T.text tag='span' text="pin_req"/>;
const numberPincode = <T.text tag='span' text="pincode_digit_validation"/>;

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pincode: '',
      pincodeError:'',
      licensePlate: '',
      licensePlateError: '',
      email: '',
      emailError:''
    };
  }

  componentWillReceiveProps(nextProps){
    console.log('Settings componentWillReceiveProps props: ', nextProps);
    let accountId = localStorage.getItem('accountId');
    if (accountId){
      this.setState({pincode: nextProps.password});
      this.setState({licensePlate: nextProps.licensePlate});
      this.setState({email: nextProps.email});
    }
  }

  componentWillMount(){
    this.setState({pincode: this.props.password});
    this.setState({licensePlate: this.props.licensePlate});
    this.setState({email: this.props.email});
  }

  onPincodeChange = (e) => {
    let val = e.nativeEvent.target.value;
    this.setState({pincode: val});
    //validation required
    if (!val) {
      this.setState({pincodeError: requirePincode});}

    else if (val && isNaN(val) == true) {
      this.setState({pincodeError: numberPincode});}
      else {
      this.setState({pincodeError: ''});
     }
  }

  onLicensePlateChange = (e) => {
    let val = e.nativeEvent.target.value;
    console.log('onLicensePlateChange ', val);
    this.setState({licensePlate: val});
    let valid = true;
    //validation required
    if (!val)
      this.setState({licensePlateError: requireLicensePlate});
    else if ( /[^A-Z0-9\-\\/]/.test(val) )
      this.setState({licensePlateError: charactersLicensePlate});
    else
      this.setState({licensePlateError: ''});
  }

  onEmailChange = (e) => {
    let val = e.nativeEvent.target.value;
    this.setState({email: val});
    //validation required
    if (!val)
      this.setState({emailError: requireEmail});
    else
      this.setState({emailError: ''});

    //email format cheking
    if ( val && !validator.isEmail(val) ){
      this.setState({emailError: formatEmail});
    }else if ( val && validator.isEmail(val) )
      this.setState({emailError: ''});
  }

  onChangeSettingsClick = (e) => {
    this.props.hideAlert()

    if (!this.validationFields())
      return;

    console.log('onChangeSettingsClick');
    this.props.saveSettings(this.props.accountId,
                      this.state.pincode,
                      this.state.licensePlate,
                      this.state.email
                    );
  }

  onBackClick = () => {
    console.log('back click');
    const { router } = this.context;
    router.history.push('/welcome');
  }

  validationFields(){
    let valid = true;
    /*required validation*/
    if (!this.state.licensePlate){
      this.setState({licensePlateError: requireLicensePlate});
      valid = false;
    }else if (/[^A-Z0-9\-\\/]/.test(this.state.licensePlate)){
      this.setState({licensePlateError: charactersLicensePlate});
      valid = false;
    }else
      this.setState({licensePlateError: ''});

    if (!this.state.pincode){
      this.setState({pincodeError: requirePincode});
      valid = false;
    }else if (this.state.pincode && isNaN(this.state.pincode) == true) {
      this.setState({pincodeError: numberPincode});
      valid = false;
    } else
      this.setState({pincodeError: ''});

    let emailVal = this.state.email;
    if (!emailVal){
      this.setState({emailError: requireEmail});
      valid = false;
    }else{
      //email format cheking
      if ( !validator.isEmail(emailVal) ){
        this.setState({emailError: formatEmail});
        valid = false;
      }else
        this.setState({emailError: ''});
    }

    return valid;
  }

  render() {

    const {isProgressSaveSettings, typeMessage, messageText
      , visible, showIndicator } = this.props;
    const message = {
      type: typeMessage,
      text: messageText
    }
      return(
      <Col sm={10} md={8}>
        <div>
          <h4 className="title-screen">
            <T.text tag='span' text="settings"/>
          </h4>

          <Form id="seetingsForm">
            <FormGroup row>

              <Label for="examplePassword" sm={4}>
                <T.span text={{ key: "pincode" }}/>
              </Label>

              <Col sm={8}>
                <Input type="password" name="password" id="examplePassword"
                  autoComplete="new-password"
                  placeholder=""
                  onChange={this.onPincodeChange}
                  value={this.state.pincode}
                  className={(this.state.pincodeError ? 'highlight-error' : '')}
                />

                {this.state.pincodeError &&
                  <p className="text-danger">{this.state.pincodeError}</p>}
              </Col>
            </FormGroup>

           <FormGroup row>
             <Label for="exampleEmail" sm={4}>
               <T.span text={{ key: "license_plate_fld" }}/>
             </Label>
             <Col sm={8}>
               <Input type="text" name="licensePlate" id="licensePlate"
                 placeholder=""
                 onChange={this.onLicensePlateChange}
                 value={this.state.licensePlate}
                 className={(this.state.licensePlateError ? 'highlight-error' : '')}
               />

               {this.state.licensePlateError &&
                 <p className="text-danger">{this.state.licensePlateError}</p>}
             </Col>
           </FormGroup>

           <FormGroup row>
             <Label for="exampleEmail" sm={4}>
               <T.span text={{ key: "email_address" }}/>
             </Label>
             <Col sm={8}>
               <Input type="text" name="emailAddr" id="emailAddr"
                 placeholder=""
                 onChange={this.onEmailChange}
                 value={this.state.email}
                 className={(this.state.emailError ? 'highlight-error' : '')}
               />

               {this.state.emailError &&
                 <p className="text-danger">{this.state.emailError}</p>}
             </Col>
           </FormGroup>
           <br/>
           {showIndicator &&
            <IndicatorLoading delay={50}/>
          }
           <ReactCSSTransitionGroup
                transitionName="appear"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}>
           {visible && <Alert message={message} />}
           </ReactCSSTransitionGroup>
           <FormGroup row className="bottom-cnt">
             <div className="col-md-6">
                <Button color="warning" className="back-btn"
                  onClick={() => this.onBackClick()}>
                    <T.text tag='span' text="back"/>
                  </Button>
             </div>

             <div className="col-md-6">
                <Button color="warning" className="settings-btn"
                  onClick={() => this.onChangeSettingsClick()}>
                    <T.text tag='span' text="change_settings"/>
                </Button>
             </div>
           </FormGroup>

         </Form>

        </div>
      </Col>
    )
  }
}

Settings.contextTypes = {
  router: React.PropTypes.object
}

export default connect(
  (state)=>{
    console.log("state ", state)
    return {
      accountId: state.authReducer.accountId,
      licensePlate: state.authReducer.licensePlate,
      email: state.authReducer.email,
      password: state.authReducer.password,
      isProgressSaveSettings: state.authReducer.isProgressSaveSettings,
      typeMessage: state.alert.type,
      messageText: state.alert.message,
      visible: state.alert.visible,
      showIndicator: state.authReducer.showIndicator
    }
  },
  { getLicansePlate, saveSettings, hideAlert }
)(Settings);



// WEBPACK FOOTER //
// ./src/components/settings/Settings.js